<template>
  <div>
    <div class="title-lable-error">
      <span class="ml-3">No machine is eligible to use this feature</span>
    </div>
    <div
      class="d-flex flex-row mt-3 ml-3"
      style="color: #757575; font-size: 0.85rem"
    >
      <div>
        You can only perform this requirement for the machines rented fixed
      </div>
    </div>
  </div>
</template>

<script>
import base from "@/scripts/base";

export default {
  extends: base,
};
</script>